module.exports = __webpack_public_path__ + "img/label_1.f3d2c30e.png";